export class OfdmaPreEqualization {
    ARRs: number;
    ARPP: number;
    AS: number;
    AMean: number;
    cmMacAddress: string;
    firstActiveSubC: number;
    fftsize: number;
    Spacing: number;
    GDRPP: number;
    qLastFloat: number[];
    usChannelId: string;
    GDRs: number;
    GDS: number;
    GDMean: number;
}
